import React, { useEffect } from "react";
import { Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, Box } from "@chakra-ui/react";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { deleteNoteAction, getJobListAction } from "../Redux/Actions/jobAction";
import { getAnimationData } from "@motionone/dom";
const AdminJobListingPage = () => {
  const { loading, jobs } = useSelector((state) => state.JobList);

  const { success } = useSelector((state) => state.jobDelete);

  const dispatch = useDispatch();

  function getData() {
    dispatch(getJobListAction());
  }

  useEffect(() => {
    
    getData();
  }, [success]);

  const handleDelete = (id) => {
    console.log("id:", id);
    dispatch(deleteNoteAction(id));
  };

  return (
    <Box w={"80%"} m="auto">
      <TableContainer>
        <Table variant="simple" colorScheme="red">
          <TableCaption>List of Job Posted</TableCaption>
          <Thead>
            <Tr>
              <Th>Company</Th>
              <Th>Role</Th>
              <Th>Location</Th>
              <Th>Edit</Th>
              <Th>Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {!loading &&
              jobs &&
              jobs.jobsList?.map((ele, i) => {
                return (
                  <Tr key={i}>
                    <Td>{ele.companyName}</Td>
                    <Td>{ele.position}</Td>
                    <Td>{ele.location}</Td>
                    <Td>
                      <CiEdit size={"30px"}></CiEdit>
                    </Td>
                    <Td>
                      <MdOutlineDeleteOutline
                        onClick={() => {
                          handleDelete(ele._id);
                        }}
                        size={"30px"}
                      ></MdOutlineDeleteOutline>
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AdminJobListingPage;
